export default "__VITE_ASSET__C80R8eoI__"